import {
    saturdayLowercase,
    sundayLowercase,
    mondayLowercase,
    tuesdayLowercase,
    wednesdayLowercase,
    thursdayLowercase,
    fridayLowercase,
} from './getRecurrenceDayAriaString.locstring.json';
import loc from 'owa-localize';

import {
    SATURDAY_KEY,
    SUNDAY_KEY,
    MONDAY_KEY,
    TUESDAY_KEY,
    WEDNESDAY_KEY,
    THURSDAY_KEY,
    FRIDAY_KEY,
} from 'owa-recurrence-types';

export default function getRecurrenceDayAriaString(day: string): string {
    switch (day) {
        case SATURDAY_KEY: {
            return loc(saturdayLowercase);
        }
        case SUNDAY_KEY: {
            return loc(sundayLowercase);
        }
        case MONDAY_KEY: {
            return loc(mondayLowercase);
        }
        case TUESDAY_KEY: {
            return loc(tuesdayLowercase);
        }
        case WEDNESDAY_KEY: {
            return loc(wednesdayLowercase);
        }
        case THURSDAY_KEY: {
            return loc(thursdayLowercase);
        }
        case FRIDAY_KEY: {
            return loc(fridayLowercase);
        }
        default: {
            return '';
        }
    }
}
